export interface GAObject {
  value?: number;
  item_list_id?: string;
  item_list_name?: string;
  currency?: string;
  coupon?: string;
  payment_type?: string;
  shipping_tier?: string;
  items: [
    {
      item_id: string;
      item_name: string;
      affiliation: string;
      coupon: string;
      currency: string;
      discount: number;
      index: number;
      item_brand: string;
      item_category: string;
      item_category2: string;
      item_category3: string;
      item_category4: string;
      item_category5: string;
      item_list_id: string;
      item_list_name: string;
      item_variant: string;
      location_id: string;
      price: number;
      quantity: number;
    }
  ];
}

export function ga4EventsViewItem(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'view_item', gObject);
  }
}

export function ga4EventsViewItemList(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'view_item_list', gObject);
  }
}

export function ga4EventsViewCart(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'view_cart', gObject);
  }
}

export function ga4EventsAddToCart(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'add_to_cart', gObject);
  }
}

export function ga4EventsRemoveFromCart(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'remove_from_cart', gObject);
  }
}

export function ga4EventsBeginCheckout(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'begin_checkout', gObject);
  }
}

export function ga4EventsAddShippingInfo(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'add_shipping_info', gObject);
  }
}

export function ga4EventsAddPaymentInfo(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'add_payment_info', gObject);
  }
}

export function ga4EventsViewSearchResults(gObject: GAObject | {}) {
  if (gObject && Object.keys(gObject).length !== 0 && window.gtag) {
    window.gtag('event', 'view_search_results', gObject);
  }
}
